<div class="instructions" [ngClass]="classesCointainer">
  <p class="instructions__title">La contraseña debe tener:</p>
  <ul class="instructions__list">
    <li class="instructions__item" [ngClass]="{
        'instructions__item--success': passwordIsDirtyAndTouched && !passwordControl.errors?.['minLength'],
        'instructions__item--error': passwordIsDirtyAndTouched && passwordControl.errors?.['minLength']
        }">
      Mínimo 8 caracteres
    </li>
    <li class="instructions__item" [ngClass]="{
        'instructions__item--success': passwordIsDirtyAndTouched && !passwordControl.errors?.['uppercase'],
        'instructions__item--error': passwordIsDirtyAndTouched && passwordControl.errors?.['uppercase']
        }">
      Al menos una mayúscula
    </li>
    <li class="instructions__item" [ngClass]="{
        'instructions__item--success': passwordIsDirtyAndTouched && !passwordControl.errors?.['lowercase'],
        'instructions__item--error': passwordIsDirtyAndTouched && passwordControl.errors?.['lowercase']
        }">
      Al menos una minúscula
    </li>
    <li class="instructions__item" [ngClass]="{
        'instructions__item--success': passwordIsDirtyAndTouched && !passwordControl.errors?.['number'],
        'instructions__item--error': passwordIsDirtyAndTouched && passwordControl.errors?.['number']
        }">
      Al menos un número
    </li>
    <li class="instructions__item" [ngClass]="{
          'instructions__item--success': passwordIsDirtyAndTouched && !passwordControl.errors?.['invalidCharacters'],
          'instructions__item--error': passwordIsDirtyAndTouched && passwordControl.errors?.['invalidCharacters']
        }">
      Al menos un carácter especial (<strong>$#%.</strong>)
    </li>
  </ul>
</div>
